import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { Authority, Permission, IndividualType, SimpleIndividual, Individual } from 'ah-api-gateways';
import PermissionsForm from '@/app/components/settings/PermissionsForm.vue';
import AccordionBox from '@/app/components/common/AccordionBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProposedUserPermissionsForm',
  props: {
  individual: { type: Object as PropType<Individual | Partial<SimpleIndividual>>, required: true },
  authorities: { type: Array as PropType<Authority[]>, required: false, default: () => [] },
},
  emits: ["update:individual"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:individual', value: Individual | Partial<SimpleIndividual>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const isAdmin = computed(() => props.individual.type === IndividualType.CLIENT_ADMIN);

function setAsAdmin(admin: boolean) {
  const type = admin ? IndividualType.CLIENT_ADMIN : IndividualType.CLIENT_INDIVIDUAL;
  emit('update:individual', { ...props.individual, proposedPermissions: [], type });
}

function setPermissions(proposedPermissions: Permission[]) {
  emit('update:individual', { ...props.individual, proposedPermissions });
}

return { __sfc: true,props, emit, isAdmin, setAsAdmin, setPermissions, PermissionsForm, AccordionBox }
}

})